/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExternalSystemEnum } from './externalSystemEnum';
import { AvailabilityModeEnum } from './availabilityModeEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface ScheduleSplitRequest { 
    weekday: number;
    weekInterval?: number;
    availabilityMode?: AvailabilityModeEnum;
    externalSystem?: ExternalSystemEnum | null;
    eventDate: string;
    fromTime: string;
    toTime: string;
    startDate: string;
    endDate?: string;
    ignoreWarnings?: boolean;
}
export namespace ScheduleSplitRequest {
}

export const ScheduleSplitRequest_weekday_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.min(0), Validators.max(6),];

export const ScheduleSplitRequest_weekInterval_Validators: ValidatorFn[] =
    [  Validators.min(1), Validators.max(8),];

export const ScheduleSplitRequest_availabilityMode_Validators: ValidatorFn[] =
    [ ];

export const ScheduleSplitRequest_externalSystem_Validators: ValidatorFn[] =
    [ ];

export const ScheduleSplitRequest_eventDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ScheduleSplitRequest_fromTime_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ScheduleSplitRequest_toTime_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ScheduleSplitRequest_startDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ScheduleSplitRequest_endDate_Validators: ValidatorFn[] =
    [ ];

export const ScheduleSplitRequest_ignoreWarnings_Validators: ValidatorFn[] =
    [ ];


